/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { MenuItem } from "@mui/material";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import images
import CommonHeader from "components/MarketplaceComponents/MarketplaceHeader/CommonHeader";
import { assetImages } from "constants";
import ProductListHeader from "../Header/ProductListHeader";
import { useTranslation } from "react-i18next";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";

import ProductFilterPopup from "../Popup/ProductFilterPopup";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import CustomerPricingUpload from "../Popup/CustomerPricingUpload"; // added import
import { replaceListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

const ProductListBody = () => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const { t, i18n } = useTranslation(); //for translation

  const [isLoading, setIsLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  // skeleton visibility control
  const [showSkeleton, setShowSkeleton] = useState(false);

  // global search
  const [globalSearch, setGlobalSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // null = popup hasn't decided yet (skip API call)
  // [] = no filter, fetch all
  // [...] = has filters, fetch filtered
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);
  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  // Pagination
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all products
  const getAllProducts = async (searchTerm = "", withSkeleton = false) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestURL =
        url.API_BASE_URL + url.API_GET_ALL_PRODUCTS + `?token=${token}`;

      // append search term if provided
      if (searchTerm && searchTerm.trim() !== "") {
        requestURL += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("requestURL --------> ", requestURL);

      const response = await getData(requestURL);

      if (response.status) {
        setProductList(response.data);
        setMessageType("success");
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    } finally {
      setShowSkeleton(false); // close skeleton
      setIsDataReady(true);
      setIsLoading(false);
    }
  };

  //function for get all filtered products
  const getAllFilteredProducts = async (
    searchTerm = "",
    withSkeleton = false,
  ) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_FILTERED_PRODUCTS + `?token=${token}`;

      // append search term if provided
      if (searchTerm && searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // sanitize the filter query for API
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","),
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = { filters: sanitizedQuery };

      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setProductList(response.data);
        setMessageType("success");
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    } finally {
      setShowSkeleton(false); // close skeleton
      setIsDataReady(true);
      setIsLoading(false);
    }
  };

  //delete product
  const deleteProductHandler = async () => {
    if (selectedProductIds.length > 0) {
      try {
        const listToBeUpdated = productList.filter((item) =>
          selectedProductIds.includes(item._id),
        );

        const apiData = {
          productlist: listToBeUpdated,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_PRODUCT + `?token=${token}`;

        const response = await putData(requestURL, apiData);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setProductList((prevList) =>
              prevList.filter((item) => !selectedProductIds.includes(item._id)),
            );
            setSelectedProductIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one product");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //after action close
  const afterActionClose = (data = []) => {
    setTimeout(() => {
      setProductList((prev) => replaceListByIds(prev, data));
    }, 1000);
    setTimeout(() => {
      setSelectedTagId(null);
      setSelectedProduct(null);
    }, 1000);
  };

  // Remove tag from product
  const removeTagFromProduct = async (tagIds, productId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_PRODUCT;
      const data = await removeTagHandler(tagIds, productId, componentUrl);
      if (data) {
        afterActionClose(data);
      }
    } catch (error) {
      // Optionally handle error
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedProduct(null);
      }, 1000);
    }
  };

  //reset filter
  const resetFilterData = () => {
    setRowSelection({});
    setSelectedProductIds([]);
    setJsonFilterQuery(null); // null = triggers fetch all via jsonFilterQuery effect
    setIsFilterReset(true);
    setReloadData(true);
    setGlobalSearch(""); // reset search input
    setDebouncedSearch(""); // reset debounced search
    setPagination({ pageIndex: 0, pageSize: 10 });
    setLastPagination({ pageIndex: 0, pageSize: 10 });
  };

  const columns = useMemo(
    () => [
      { accessorKey: "sku", header: "SKU" },
      {
        accessorKey: "productimagepath",
        header: "Image",
        Cell: ({ cell, row }) => {
          const imagePath = row.original.productimagepath
            ? url.SERVER_URL + row.original.productimagepath
            : "https://placehold.co/50x50";
          return (
            <img
              className="rounded"
              src={imagePath}
              alt="Product"
              style={{ width: 50, height: 50 }}
            />
          );
        },
      },
      {
        accessorKey: "tagstring",
        header: t("Label"),
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.productlabels &&
                  row.original.productlabels.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.productlabels &&
                    row.original.productlabels.map((tag, index) => (
                      <li key={index} className="d-inline-flex">
                        <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                          <span className="badge-text fs-xs fw-medium me-1">
                            {tag.title}
                          </span>
                          <Link
                            to="#"
                            className={`${
                              tag.moderator?.toString() ===
                                userInfo._id.toString() ||
                              userInfo.role.slug === "ADMIN" ||
                              userInfo.role.slug === "SUPER_ADMIN"
                                ? "d-block"
                                : "d-none"
                            }`}
                            onClick={() => {
                              setSelectedProduct(row.original._id);
                              setSelectedTagId(tag._id);
                              removeTagFromProduct([tag._id], row.original._id);
                            }}
                          >
                            {selectedTagId &&
                            selectedTagId === tag._id &&
                            selectedProduct &&
                            selectedProduct === row.original._id ? (
                              <div
                                className="spinner-border spinner-border-sm text-primary ms-1"
                                role="status"
                                style={{ height: "12px", width: "12px" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              <span
                                className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                                style={{ cursor: "pointer" }}
                              >
                                cancel
                              </span>
                            )}
                          </Link>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedProductIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      { accessorKey: "name", header: "Product Name" },
      { accessorKey: "categorynames", header: "Categories" },
      { accessorKey: "companyname", header: "Seller" },
      { accessorKey: "price", header: "Price" },
      { accessorKey: "stock", header: "Stock" },
      { accessorKey: "taxpercent", header: "Vat" },
      { accessorKey: "producttypename", header: "Type" },
      { accessorKey: "totalratings", header: "Rating" },
      { accessorKey: "productstatuslabel", header: "Status" },
    ],
    [t, selectedTagId, selectedProduct, userInfo._id, userInfo.role.slug],
  );

  // initialize column visibility — all visible by default
  const initialVisibilityState = columns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  // handle column visibility change from MRT
  const onColumnVisiblityHandler = (newColumnState) => {
    if (typeof newColumnState === "function") {
      const newColumnStateName = newColumnState();
      setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
    } else {
      setVisibleColoumns(newColumnState);
    }
  };

  // initialize column order
  const initialColumnOrder = [
    "mrt-row-actions",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  // handle column order change from MRT
  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  // reset columns to default
  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  // single API trigger — fires only after popup has decided
  // null guard prevents API call before popup responds
  useEffect(() => {
    if (jsonFilterQuery === null) return; // popup not ready yet, wait

    if (jsonFilterQuery.length > 0) {
      getAllFilteredProducts(debouncedSearch, true); // filter apply — show skeleton
    } else {
      getAllProducts(debouncedSearch, true); // no filter — show skeleton
    }
  }, [jsonFilterQuery]);

  // search effect — no skeleton, table stays visible while typing
  // isDataReady guard prevents running before initial load finishes
  useEffect(() => {
    if (!isDataReady) return; // wait for initial load to finish

    if (jsonFilterQuery && jsonFilterQuery.length > 0) {
      getAllFilteredProducts(debouncedSearch, false); // no skeleton while typing
    } else {
      getAllProducts(debouncedSearch, false); // no skeleton while typing
    }
  }, [debouncedSearch]);

  // reload effect — always show skeleton
  useEffect(() => {
    if (reloadData) {
      setIsFilterReset(true);
      getAllProducts("", true); // show skeleton on reload
      setReloadData(false);
    }
  }, [reloadData]);

  // debounce — waits 600ms after user stops typing then triggers search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(globalSearch);
    }, 600);
    return () => clearTimeout(timer);
  }, [globalSearch]);

  // row selection effect
  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );

    if (selectedIdsArray.length > 0) {
      setSelectedProductIds(selectedIdsArray);
    } else {
      setSelectedProductIds([]);
    }
  }, [rowSelection]);

  // save last pagination
  useEffect(() => {
    setLastPagination({
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    });
  }, [pagination.pageIndex, pagination.pageSize]);

  /* Closes the alert by updating the state variables.*/
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_MARKETPLACE")
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          {/* ---- common header ---- */}
          <CommonHeader activeOption="Products" />
          <div className="container-fluid px-lg-5">
            {/* header */}
            <ProductListHeader
              reloadList={refreshRecords}
              selectedProductIds={selectedProductIds}
              jsonFilterQuery={jsonFilterQuery ?? []} // ✅ null guard
            />

            {/* table */}
            {!isDataReady || showSkeleton ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={productList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns, // column visibility
                    columnOrder: columnOrder, // column order
                    globalFilter: globalSearch || undefined, // bind search to MRT
                  }}
                  onPaginationChange={setPagination}
                  autoResetPageIndex={false}
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  enableRowActions
                  renderRowActionMenuItems={({ row }) => [
                    <MenuItem
                      key="edit"
                      //onClick={() => console.info(row.id)}
                    >
                      <Link
                        className="dropdown-item"
                        to={`/admin/marketplace/product/details/${row.id}`}
                      >
                        {t("View Details")}
                      </Link>
                    </MenuItem>,
                    <MenuItem
                      key="category"
                      //onClick={() => console.info(row.id)}
                    >
                      <Link
                        className="dropdown-item"
                        to={`/admin/marketplace/product/category/${row.id}`}
                      >
                        {t("Category")}
                      </Link>
                    </MenuItem>,
                    <MenuItem
                      key="variants"
                      //onClick={() => console.info(row.id)}
                    >
                      <Link
                        className="dropdown-item"
                        to={`/admin/marketplace/product/variants/${row.id}`}
                      >
                        {t("Variants")}
                      </Link>
                    </MenuItem>,
                    <MenuItem
                      key="offers"
                      //onClick={() => console.info(row.id)}
                    >
                      <Link
                        className="dropdown-item"
                        to={`/admin/marketplace/product/offers/${row.id}`}
                      >
                        {t("Offers")}
                      </Link>
                    </MenuItem>,
                    <MenuItem
                      key="gallery"
                      //onClick={() => console.info(row.id)}
                    >
                      <Link
                        className="dropdown-item"
                        to={`/admin/marketplace/product/gallery/${row.id}`}
                      >
                        {t("View Gallery")}
                      </Link>
                    </MenuItem>,
                  ]} // action columns menu items
                  enableColumnOrdering={true} // enable drag to reorder
                  onColumnVisibilityChange={onColumnVisiblityHandler} // column visibility handler
                  onColumnOrderChange={changeColumnOrderHandler} // column order handler
                  onGlobalFilterChange={(value) => setGlobalSearch(value ?? "")} // typing triggers debounced search
                  muiTableContainerProps={{ sx: { maxHeight: "60vh" } }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
          {/* ----- all pop up render here ----- */}
          {/* ----------- delete warning modal ------------ */}
          <DeleteWarningModal
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedProductIds([]);
            }}
            onDelete={deleteProductHandler}
            moduleName={t("product")}
          />

          {/* ------ Product Filter --------------- */}
          <ProductFilterPopup
            moduleSlug="productlist"
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={resetFilterData}
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
            visibleColoumns={visibleColoumns}
            setVisibleColoumns={setVisibleColoumns}
            columnOrder={columnOrder}
            setColumnOrder={setColumnOrder}
          />

          <AddLabelModal
            moduleName="product"
            afterTagModalClose={afterActionClose}
            selectedIds={selectedProductIds}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setSelectedProductIds([]);
              setRowSelection({});
            }}
          />

          {/* render the offcanvas component so its markup is present */}
          <CustomerPricingUpload
            productList={productList.filter((item) =>
              selectedProductIds.includes(item._id),
            )}
            onClose={() => {
              setSelectedProductIds([]);
              setRowSelection({});
            }}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default ProductListBody;
